const grid = {
  breakpoints: {
    sm: 0,
    md: 48,
    lg: 75
  }
};
export { grid as default };